module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral420: #636363;
  --primitiveColorNeutral540: #828282;
  --primitiveColorNeutral720: #b1b1b1;
  --primitiveColorNeutral970: #eeeeee;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorYellow870: #ffd400;
  --primitiveColorYellow890: #ffdd33;
  --primitiveColorYellow930: #ffe97f;
  --primitiveColorBlue170: #042c49;
  --primitiveColorBlue300: #004a79;
  --primitiveColorBlue470: #0076c2;
  --primitiveColorBlue870: #c2ddef;
  --primitiveColorError440: #cc0033;
  --primitiveTypographyTypescale1: 3.375rem;
  --primitiveTypographyTypescale2: 2.25rem;
  --primitiveTypographyTypescale3: 1.5rem;
  --primitiveTypographyTypescale4: 1.125rem;
  --primitiveTypographyTypescale5: 1rem;
  --primitiveTypographyTypescale6: .875rem;
}
`;